import { Flex, Modal } from 'app/components/design-system-components'
import Spinner from 'app/sm/common/spinner'

function ProcessingDocuments({ toggleModal = () => {} }) {
  return (
    <Modal
      modalBody={
        <Flex width="100%" justifyContent="center">
          <Spinner text={undefined} />
        </Flex>
      }
      modalHeading="Processing Documents"
      modalFooter={null}
      customModalFooter={true}
      primaryLabel={undefined}
      primaryAction={undefined}
      secondaryLabel={undefined}
      secondaryAction={undefined}
      toggleModal={toggleModal}
    />
  )
}

export default ProcessingDocuments
